@if (isLoading()) {
  <div class="loading-overlay">
    <div class="loading-content">
      <div id="eco-loading"></div>
    </div>
  </div>
}
